// The frame Free resources and Free webinars share: their own header (SubHeader), the payment
// banner every shell page has while a payment is overdue (docs/data-model.md 3.2), the page, and
// the footer with the help address (decision 38). The page head is the boards' lines 61 to 68.
// While staff view as a member, the shared read-only line (lib/viewAs.jsx) sits at the top of the
// page, as on Account and the Library, so both free pages say so even where nothing is pressed.
// back ({ to, label }) is a page further in, a replay's own (Adam, 23 Oct): its way back up starts the
// page at both widths, in place of the phone's "Library" (the laptop's header keeps its "Library").
import { useEffect } from 'react'
import { SITE, setTitle } from '../config/site.js'
import { useMember } from '../app/member.jsx'
import { useLibraryModel } from '../library/useModel.js'
import { usePhone } from '../lib/media.js'
import { Link } from '../lib/router.jsx'
import { Footer } from '../shell/Shell.jsx'
import { ReadOnlyNote } from '../lib/viewAs.jsx'
import { PaymentBanner } from '../shell/PaymentBanner.jsx'
import { SubHeader, BackLink } from './SubHeader.jsx'
import '../styles/shell.css'
import '../styles/library.css'
import '../styles/free.css'

export function FreePage({ title, variant, back = null, children }) {
  const { me, ensureLibrary, markRead } = useMember()
  const model = useLibraryModel()
  const phone = usePhone()
  useEffect(() => { setTitle(title) }, [title])
  useEffect(() => { ensureLibrary() }, [ensureLibrary])
  return (
    <div className="sh-page fp-page">
      <SubHeader model={model} person={me.person} phone={phone} onOpenBell={markRead} />
      {model && <PaymentBanner text={model.banner} target={model.bannerFor} phone={phone} />}
      <main className={variant ? `fp-main fp-main--${variant}` : 'fp-main'}>
        {back
          ? <BackLink to={back.to} label={back.label} className={phone ? 'fw-back fp-back--phone' : 'fw-back'} />
          : phone && <BackLink className="fp-back fp-back--phone" />}
        <ReadOnlyNote />
        {children}
      </main>
      <Footer phone={phone} />
    </div>
  )
}

// "Free with your account", the heading, the line under it, and the way to the other free page
export function PageHead({ heading, lede, other }) {
  return (
    <section className="fp-head">
      <div className="fp-head-text">
        <div className="fp-eyebrow">Free with your account</div>
        <h1 className="fp-h1">{heading}</h1>
        <p className="fp-lede">{lede}</p>
      </div>
      {other && <Link to={other.to} className="fp-head-link">{other.label}</Link>}
    </section>
  )
}

// The page's own rows didn't load. The same words as the app's other "didn't load" notice.
export function LoadFailed({ onRetry }) {
  return (
    <div className="fp-failed" role="alert">
      <p className="fp-failed-line">That didn't load. Check your connection and try again. If it keeps happening, email {SITE.helpEmail}.</p>
      <button type="button" className="btn btn-ink" onClick={onRetry}>Try again</button>
    </div>
  )
}

